/** biome-ignore-all lint/correctness/useExhaustiveDependencies: <Not needed> */
"use client";

import { useEffect, useState } from "react";

const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<number | null>(null);

  const handleResize = () => {
    const width = globalThis.window?.innerWidth;
    setWindowSize(width);
  };

  useEffect(() => {
    handleResize();

    globalThis.window?.addEventListener("resize", handleResize);
    return () => {
      globalThis.window?.removeEventListener("resize", handleResize);
    };
  }, []);

  return { windowSize };
};

export default useWindowSize;
